import clsx from 'clsx'
import {FC} from 'react'
import {hasMegaPayBusinessCapabilities} from '../../../../_metronic/helpers/brand'
import {useIsOnPremises} from '../../auth/core/useOnPremises'
import {hidesPayments} from '../../install-app/core/androidApp'
import {serviceIntroUrl} from '../core/serviceIntro'

/**
 * «معرفی»: the service's own block on the website («سرویس‌های ویژه»), in a new tab so the page and what was typed
 * stay. Only on ASA's own panel: an on-premises install and another brand's panel have no such page.
 */
export const ServiceIntroLink: FC<{feature?: string | null; label?: string; className?: string; iconOnly?: boolean}> = ({
  feature,
  label,
  className,
  iconOnly = false,
}) => {
  const onPremises = useIsOnPremises()
  const url = serviceIntroUrl(feature)
  if (!url || onPremises || hidesPayments() || !hasMegaPayBusinessCapabilities()) return null
  const name = `معرفی ${label ? `«${label}»` : 'این سرویس'} در سایت (در زبانهٔ تازه)`
  return (
    <a
      href={url}
      target='_blank'
      rel='noopener noreferrer'
      className={clsx('svc-intro-link', {'is-icon': iconOnly}, className)}
      aria-label={name}
      title={name}
    >
      <i className='las la-info-circle' aria-hidden='true'></i>
      {!iconOnly && <span>معرفی</span>}
    </a>
  )
}
